import { useEffect } from "react";

// Sets document title + meta description for SEO on public pages.
export function PageMeta({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) { m = document.createElement("meta"); m.setAttribute("name", "description"); document.head.appendChild(m); }
      m.setAttribute("content", description);
    }
    return () => { document.title = "Nearfluence"; };
  }, [title, description]);
  return null;
}
